import React from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { FullScreenLoader } from "components/Loader";
import { useAnswerContext } from "contexts/answerContext";
import useAbortableEffect from "hooks/useAbortableEffect";
import useParam from "hooks/useParam";
import { useSubmitApplication } from "queries/requirementApplications";
import { useRequirementBySlug } from "queries/requirements";
import { getRequirementApplicationByRequirementID } from "reducers/projects";
import { getInvoiceID, wasSubmitted } from "reducers/requirementApplications";
import { isPresent } from "utils/func";

const SubmitApplication = () => {
  const navigate = useNavigate();

  const answerContext = useAnswerContext();
  const { record: project, pending: isPendingSave } = answerContext;

  // HACK: inject the requirement into answerContext as `context`, as if we're inside a mapped answerContext
  const requirementSlug = useParam("requirementSlug");
  const { data: requirement, isLoading } = useRequirementBySlug(requirementSlug);

  const { mutateAsync: submitApplication } = useSubmitApplication();

  useAbortableEffect(
    ({ aborted }) =>
      (async () => {
        if (isPendingSave || isLoading) return;

        let application = getRequirementApplicationByRequirementID(project, requirement.id);
        if (!application) {
          const error = new Error("Application non-existent");
          error.context = { projectID: project.id, requirementSlug, requirementID: requirement.id };
          throw error;
        }

        if (!wasSubmitted(application)) {
          if (aborted) return;
          const { data: updatedApplication } = await submitApplication(application.id);
          application = updatedApplication;
        }

        const invoiceID = getInvoiceID(application);
        const nextURL = isPresent(invoiceID)
          ? `/projects/${project.id}/requirements/${requirementSlug}/payment/${invoiceID}`
          : `/projects/${project.id}/requirements/${requirementSlug}/summary`;

        setTimeout(() => navigate(nextURL), 0);
      })(),
    [isPendingSave, isLoading, requirement, submitApplication, navigate],
  );

  return <FullScreenLoader label="SubmitApplication" />;
};

export default SubmitApplication;
